module.exports = __webpack_public_path__ + "media/images/thumbs/physanims/a3-9-42a03a1f070dd4e44e7bbc16593e54ae.jpg";